import { Container, Divider, Grid, Paper, Tooltip, Typography } from '@material-ui/core'
import React, { useContext } from 'react'
import FlexView from 'react-flexview/lib'
import { FormContext, useForm } from 'react-hook-form'
import { ACTIONS, PolicyModificationContextStore } from '../../../../context/PolicyModificationContext'
import { CentPretty, awaitWithLoading, currencySymbol } from '../../../../services/utils'
import './OdometerModificationSection.scss'
import { OdometerMotorcycleSection } from './OdometerMotorcycleSection'
import { ContinueButton } from '../../../Core/Buttons/ContinueButton'
import { Action } from '../../../../models/Action'
import policyModificationApi from '../../../../api/policyModification.api'
import { ReactComponent as ShieldSvg } from '../../../../assets/shield_with_v.svg'
import coveragesApi from '../../../../api/coverages.api'

export const OdometerDetailsModification = ({ onContinue }) => {
  const modifyContext = useContext(PolicyModificationContextStore)
  const form = useForm({ mode: 'onBlur', defaultValues: {} })

  React.useEffect(() => {
    const getVehicleDetails = async () => {
      const vehicleDetails = await awaitWithLoading(
        policyModificationApi.getVehicleOdometerDetails(
          {
            insurance_id: modifyContext.insuranceId,
            policy_owner_details: modifyContext.owner_details,
            insured_vehicles: modifyContext.motorcycles_details,
            insured_persons: modifyContext.rider_details,
            policy_coverages: modifyContext.policy_coverages,
            billing_period: modifyContext.billingPeriod,
            is_renewal: modifyContext.isRenewal,
          },
          modifyContext.insuranceId
        )
      )
      if (vehicleDetails.ok) {
        modifyContext.dispatch(new Action(ACTIONS.SET_MOTERCYCLES_ODOMETER_DETAILS, vehicleDetails.data.result))
      }
    }
    getVehicleDetails()
  }, [])

  const handleContinue = async data => {
    const formData = new FormData()
    for (const key in data) {
      formData.append(key, data[key])
    }

    const odometerUploadResult = await awaitWithLoading(policyModificationApi.uploadOdometers(formData, modifyContext.insuranceId))
    if (odometerUploadResult.ok) {
      modifyContext.dispatch(new Action(ACTIONS.SAVE_ODOMETER_DATA))
    }
  }

  return (
    <React.Fragment>
      <div className="text-title bold black margin-bottom-basic blue">Motorcycle Details</div>
      <Grid xs={12} container>
        <Grid item xs={8}>
          <FormContext {...form}>
            <form autoComplete="off" onSubmit={form.handleSubmit(handleContinue)}>
              {modifyContext.motorcycles_odometer_details.map((m, index) => (
                <>
                  <OdometerMotorcycleSection motorcycleDetails={m} />
                  {index !== modifyContext.motorcycles_odometer_details.length - 1 && <Divider />}
                </>
              ))}
              <Grid xs={4}>
                <FlexView vAlignContent="center" hAlignContent="left" className="margin-top-large">
                  <ContinueButton label="Continue" type="submit" />
                </FlexView>
              </Grid>
            </form>
          </FormContext>
        </Grid>
      </Grid>
    </React.Fragment>
  )
}
